import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal} from 'antd'
import {QuestionCircleFilled, EditOutlined, DeleteOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import FormModal from './FormModal'
const {confirm} = Modal

@inject('remarkTemplateListStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
  }

  handlePageChange = (page, pageSize) => {
    const {remarkTemplateListStore} = this.props
    remarkTemplateListStore.onChangePageNumAction(page, pageSize)
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  handleEdit = (record) => {
    const {remarkTemplateListStore} = this.props
    remarkTemplateListStore.onGetJobAction(record.id).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const {remarkTemplateListStore, t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        remarkTemplateListStore.onDeleteJobAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }

  render() {
    const {remarkTemplateListStore, t} = this.props
    const {pageNo, pageSize, itemCount, remarkList} = remarkTemplateListStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const columns = [
      {
        title: t(`outboundCall.surveyName`),
        dataIndex: 'questionName',
        key: 'questionName',
        ellipsis: true
      },
      {
        title: t(`outboundCall.updateTime`),
        dataIndex: 'updateTime',
        key: 'updateTime',
        ellipsis: true
      },
      {
        title: t(`outboundCall.operator`),
        dataIndex: 'createUser',
        key: 'createUser',
        ellipsis: true
      },
      {
        align: 'center',
        title: t(`general.action`),
        key: 'action',
        width: 200,
        render: (text, record) => (
          <>
            <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
            <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
          </>
        )
      }
    ]
    
    return (
      <>
        <Table 
          className="searchResult" 
          dataSource={toJS(remarkList)} 
          pagination={pagination} 
          rowKey="id" 
          rowClassName={this.getRowClassName}
          columns={columns}
          scroll={{x: '100%'}}
        />
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}
      </>
    )
  }
}


export default withTranslation()(SearchResult)
